import React, { useState } from "react";
import { IStoryblokStory } from "~src/interfaces/storyblock";
import styles from "./infomeeting-modal.module.scss";
import IconCheckCircle from "@ef-global/web-ui-react/lib/icons/IconCheckCircle";
import { IMarketData } from "../../interfaces";
import { Surface } from "@ef-global/web-ui-react/lib/components/Surface";
import FormsX from "../../../formsx/formsx";
import InfomeetingFormSuccess from "../infomeeting-form-success/infomeeting-form-success";
import { FormStatus } from "~src/interfaces/forms";
import { getHref } from "~/src/helpers/generic-helpers";
import { Modal } from "@ef-global/web-ui-react";
import InfomeetingFormError from "../infomeeting-form-error/infomeeting-form-error";

const INFOMEETING_FORM_TYPE = "infomeeting";
const FORM_FIELDS = [
  "firstName",
  "lastName",
  "mobilePhone",
  "email",
  "birthDate",
  "checkboxCombined",
];

export interface IInfomeetingModalProps {
  isOpen: boolean;
  toggleModal: (id?: string) => void;
  infomeeting: IMarketData;
  market: string;
  form_type: string;
  form_recording_button: string;
  form_title: string;
  form_task_title: string;
  form_success_screen: any;
  form_error_screen: any;
  form_edit_submission_screen: FormStatus;
  story: IStoryblokStory;
}

const InfomeetingModal = (props: IInfomeetingModalProps) => {
  const {
    isOpen,
    toggleModal,
    infomeeting,
    market,
    form_title,
    form_task_title,
    form_success_screen,
    form_error_screen = null,
    form_edit_submission_screen,
  } = props;

  const [formStatus, setFormStatus] = useState(FormStatus.NOT_SUBMITTED);

  const developFormStatus =
    form_edit_submission_screen || FormStatus.NOT_SUBMITTED;
  // Enables the preview screens during Storyblok editing
  if (getHref().includes("editor") && developFormStatus !== formStatus) {
    setFormStatus(FormStatus[developFormStatus]);
  }

  return (
    <Modal task open={isOpen} onDismiss={() => toggleModal()}>
      {/** @ts-ignore */}
      <Modal.Header>
        {/** @ts-ignore */}
        <Modal.Title>{form_task_title}</Modal.Title>
      </Modal.Header>
      <Modal.Content className={`${styles.infomeetingModalContent}`}>
        {formStatus === FormStatus.SUBMITTED && (
          <InfomeetingFormSuccess section={form_success_screen?.[0] ?? []} />
        )}
        {formStatus === FormStatus.FAILED && (
          <InfomeetingFormError section={form_error_screen?.[0] ?? []} />
        )}
        {infomeeting && formStatus === FormStatus.NOT_SUBMITTED && (
          <div className={`${styles.infomeetingModal} ef-row`}>
            <div className="ef-col -s-12">
              <Surface className={`${styles.surfaceInfo}`}>
                <IconCheckCircle className={styles.infoCheck} />
                <p className="u-mb-0">{infomeeting.date}</p>
                <p
                  className={`u-mb-0 ${
                    infomeeting?.offlineAddress || infomeeting?.eventLocation
                      ? "u-mb-l"
                      : ""
                  }`}
                >
                  {infomeeting.title}
                </p>
                {infomeeting?.offlineAddress ? (
                  <>
                    <p className="u-mb-0 u-mt-6">
                      {infomeeting.offlineAddress?.street}
                    </p>
                    <p className="u-mb-0">
                      {infomeeting.offlineAddress?.city},{" "}
                      {infomeeting.offlineAddress?.postalCode}
                    </p>
                  </>
                ) : (
                  <></>
                )}
              </Surface>
            </div>
            <div className="ef-col -s-12 u-mt-xl u-mb-xl">
              <p className="u-mb-0">{infomeeting.description}</p>
            </div>
            <div className="ef-col -s-12">
              <p className="ef-h6 u-mb-l">{form_title}</p>
              <FormsX
                market={market}
                form_type={INFOMEETING_FORM_TYPE}
                eventId={infomeeting.id}
                visibleFields={FORM_FIELDS}
                onSubmissionError={() => {
                  setFormStatus(FormStatus.FAILED);
                }}
                onSubmissionCompleted={() => {
                  setFormStatus(FormStatus.SUBMITTED);
                }}
                story={props.story}
                infomeeting={infomeeting}
              />
            </div>
          </div>
        )}
      </Modal.Content>
    </Modal>
  );
};

export default InfomeetingModal;
